// extracted by mini-css-extract-plugin
export default {"container":"PriceList_container__UpzQ3","wrapper":"PriceList_wrapper__1o8Qs","screenReaderOnly":"PriceList_screenReaderOnly__Cm4L5","footerStyle":"PriceList_footerStyle__VXXp3"};